import { useEffect } from 'react';
import { C } from '../utils/constants';

const PARTICLE_COLORS = [C.gold, C.amber, '#FFD700', '#FFA500', '#FF6B35', C.terracotta];

const randomBetween = (min, max) => Math.random() * (max - min) + min;

export const Celebration = ({ onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4500);
    return () => clearTimeout(timer);
  }, [onClose]);

  const particles = Array.from({ length: 40 }, (_, i) => {
    const angle = (i / 40) * 360 + randomBetween(-20, 20);
    const distance = randomBetween(80, 220);
    const rad = (angle * Math.PI) / 180;
    const tx = Math.cos(rad) * distance;
    const ty = Math.sin(rad) * distance;
    const size = randomBetween(6, 14);
    const color = PARTICLE_COLORS[Math.floor(Math.random() * PARTICLE_COLORS.length)];
    const duration = randomBetween(0.8, 1.6);
    const delay = randomBetween(0, 0.3);

    return { tx, ty, size, color, duration, delay };
  });

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.72)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}>
      {/* Particles */}
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
        {particles.map((p, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              width: p.size,
              height: p.size,
              borderRadius: '50%',
              background: p.color,
              '--tx': `${p.tx}px`,
              '--ty': `${p.ty}px`,
              animation: `explode ${p.duration}s ease-out ${p.delay}s both`,
              boxShadow: `0 0 4px ${p.color}`,
            }}
          />
        ))}
      </div>

      {/* Popup card */}
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 400,
        width: '90%',
        textAlign: 'center',
        position: 'relative',
        animation: 'popIn 0.5s cubic-bezier(0.34,1.56,0.64,1) both',
        boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
      }}>
        {/* Star emoji with pulse */}
        <div style={{
          fontSize: '3.5rem',
          marginBottom: 16,
          display: 'inline-block',
          animation: 'pulse 1.2s ease-in-out infinite',
        }}>
          ⭐
        </div>

        <h2 style={{
          fontFamily: "'Forum', serif",
          color: C.brown,
          fontSize: '2rem',
          letterSpacing: '0.04em',
          marginBottom: 8,
        }}>
          Well Done!
        </h2>

        <p style={{
          fontFamily: "'Forum', serif",
          color: C.amber,
          fontSize: '1.15rem',
          letterSpacing: '0.06em',
          marginBottom: 16,
        }}>
          Celebrating You!
        </p>

        <p style={{
          color: C.text,
          fontSize: '0.95rem',
          lineHeight: 1.65,
          marginBottom: 28,
          opacity: 0.85,
        }}>
          You've just completed today's video training. Every step forward is a step toward the version of you that you're becoming.
        </p>

        <button
          className="btn-primary"
          onClick={onClose}
          style={{ width: '100%' }}
        >
          Continue to Journalling →
        </button>
      </div>
    </div>
  );
};
